module.exports = __webpack_public_path__ + "static/media/proposition.b96c9457.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/aa/form/proposition.pdf
// module id = 823
// module chunks = 40